import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/')({
  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.ITDR_CONFIGURATION;
    const app = APP_PATHS.IDENTITIES;
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path, app });
    context.validatePermissions({ isAllowed, preload });
  },
});
